module.exports = __webpack_public_path__ + "static/media/page92_03.b6dfc907.jpg";